import { Reveal, SectionTag } from "./motion";
import { GALLERY } from "../lib/site";

export default function Galeria() {
  return (
    <section className="py-24 md:py-32 bg-sand" data-testid="galeria-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-2xl mb-14">
          <SectionTag>Galeria</SectionTag>
          <h2 className="mt-5 font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-brand-deep text-balance">
            Momentos que viram <span className="font-serif italic font-medium text-brand-light">memórias</span>
          </h2>
        </Reveal>

        <div className="columns-2 md:columns-3 gap-4 [column-fill:balance]" data-testid="galeria-grid">
          {GALLERY.map((g, i) => (
            <Reveal key={g.img + i} delay={(i % 3) * 0.08} className="mb-4 break-inside-avoid">
              <div className="group relative overflow-hidden rounded-2xl">
                <img
                  src={g.img}
                  alt={g.alt}
                  loading="lazy"
                  className="w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-brand-deep/0 transition-colors duration-500 group-hover:bg-brand-deep/25" />
                <p className="absolute bottom-4 left-4 right-4 text-white text-xs font-semibold opacity-0 translate-y-2 transition-[opacity,transform] duration-500 group-hover:opacity-100 group-hover:translate-y-0 drop-shadow">
                  {g.alt}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
